export default "__VITE_ASSET__CiEqN8Gg__"